import { useSearchParams } from 'react-router-dom';

import { ButtonsSelect } from '@/components/Elements/ButtonSelect';

export const NotificationsToolbar = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const status = searchParams.get('status') ?? 'sent';
	return (
		<ButtonsSelect
			value={status}
			onChange={(e) => {
				const nextParams = new URLSearchParams(searchParams);
				if (e) nextParams.set('status', e);
				else nextParams.delete('status');
				setSearchParams(nextParams, { replace: true });
			}}
			options={[
				{ name: 'sent', value: 'sent' },
				{ name: 'scheduled', value: 'scheduled' },
			]}
		/>
	);
};
